"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
class KarmaError extends Error {
    constructor(data) {
        super();
        this.type = "connectionError" /* ConnectionError */;
        if (data) {
            // Currently not all errors are 'humanReadableError'
            if (data.humanReadableError) {
                const typeKey = Object.keys(data.humanReadableError.machine)[0];
                this.type = typeKey;
                this.message = data.humanReadableError.human;
                this.data = data.humanReadableError.machine[typeKey];
            }
            else {
                const typeKey = Object.keys(data)[0];
                this.type = typeKey;
                this.message = this.type;
                this.data = data[typeKey];
            }
        }
    }
}
exports.KarmaError = KarmaError;
exports.CodedHeader = 'X-Karma-Codec';
exports.SignatureHeader = 'X-Karma-Signature';
function headersForSession(session, headers = {}) {
    if (session)
        headers[exports.SignatureHeader] = session.signature;
    return headers;
}
exports.headersForSession = headersForSession;
function headersForCodec(codec, headers = {}) {
    headers[exports.CodedHeader] = codec;
    return headers;
}
exports.headersForCodec = headersForCodec;
function bodyForData(data, codec) {
    switch (codec) {
        case "json" /* JSON */: return JSON.stringify(data);
    }
}
exports.bodyForData = bodyForData;
function postUploadRequest(url, data, session, codec = "json" /* JSON */) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const headers = headersForSession(session, headersForCodec(codec));
            const result = yield axios_1.default.post(url, bodyForData(data, codec), { headers });
            return result.data;
        }
        catch (e) {
            const err = e;
            if (err.response && err.response.data) {
                throw new KarmaError(err.response.data);
            }
            throw new KarmaError();
        }
    });
}
function postRequest(url, data, session, codec = "json" /* JSON */) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const headers = headersForSession(session, headersForCodec(codec));
            const result = yield axios_1.default.post(url, bodyForData(data, codec), { headers });
            return result.data;
        }
        catch (e) {
            const err = e;
            if (err.response && err.response.data) {
                throw new KarmaError(err.response.data);
            }
            throw new KarmaError();
        }
    });
}
function binaryGetRequest(url, session, codec = "json" /* JSON */) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const headers = headersForSession(session, headersForCodec(codec));
            const result = yield axios_1.default.get(url, { headers, responseType: 'arraybuffer' });
            return result.data;
        }
        catch (e) {
            const err = e;
            if (err.response && err.response.data) {
                throw new KarmaError(err.response.data);
            }
            throw new KarmaError();
        }
    });
}
function query(url, session, expression, codec = "json" /* JSON */) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield postRequest(url, expression, session, codec);
    });
}
exports.query = query;
function reset(url, session, codec = "json" /* JSON */) {
    return __awaiter(this, void 0, void 0, function* () {
        yield postRequest(url + '/admin/reset', undefined, session, codec);
    });
}
exports.reset = reset;
function authenticate(url, username, password, codec = "json" /* JSON */) {
    return __awaiter(this, void 0, void 0, function* () {
        const data = { username, password };
        const signature = yield postRequest(url + '/auth', data, undefined, codec);
        return { username, signature };
    });
}
exports.authenticate = authenticate;
function exportDB(url, session, codec = "json" /* JSON */) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield binaryGetRequest(url + '/admin/export', session, codec);
    });
}
exports.exportDB = exportDB;
function importDB(url, session, data, codec = "json" /* JSON */) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield postUploadRequest(url + '/admin/import', data, session, codec);
    });
}
exports.importDB = importDB;
class Client {
    constructor(url, codec = "json" /* JSON */) {
        this.url = url;
        this.codec = codec;
    }
    query(expression) {
        return query(this.url, this.session, expression, this.codec);
    }
    authenticate(username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            this.session = yield authenticate(this.url, username, password, this.codec);
            return this.session;
        });
    }
    reset() {
        return reset(this.url, this.session, this.codec);
    }
    exportDB() {
        return exportDB(this.url, this.session, this.codec);
    }
    importDB(data) {
        return importDB(this.url, this.session, data, this.codec);
    }
}
exports.Client = Client;
//# sourceMappingURL=api.js.map